import { req } from "@/api/api_request";

// 获取获取站点列表
export function getStationList({ group_id, name, page, size, dev_types }) {
  let url = `station/get-list?group_id=${group_id}`;
  if (name) {
    url += `&name=${name}`;
  }
  if (page) {
    url += `&page=${page}`;
  }
  if (size) {
    url += `&size=${size}`;
  }
  if (dev_types) {
    url += `&dev_types=${dev_types}`;
  }
  return req.get(url);
}

// 获取在线小时数
export function getOnlineRate(group_id, start_time, end_time) {
  let url = `station/online-rate?group_id=${group_id}&start_time=${start_time}&end_time=${end_time}`;
  return req.get(url);
}

// 根据group_id获取站点列表
export function getStationListByGroupId(group_id) {
  let url = `/py_web_api/station?pid=${group_id}`;
  return req.get(url);
}

// 更新站点运维状态
export function updateStationOperationStatus(sid, oprt) {
  let url = `/py_web_api/station/operation?oprt=${oprt}&sid=${sid}`;
  return req.put(url);
}

// 根据id更新站点信息
export function updateStationInfoById(params) {
  let url = `/py_web_api/station`;
  return req.put(url, params);
}
